const FILTER_KEY_SEPARATOR = ":";

/* Filter Key utils */
export const buildFilterKey = (
  filterType: string,
  filterValue: string
): string => {
  return filterType + FILTER_KEY_SEPARATOR + filterValue;
};

export const buildFilterKeys = (filterKeys: string[]) => {
  return filterKeys.join(",");
};

export const isFilterKeyOfType = (
  filterKey: string,
  filterType: string
): boolean => {
  return filterKey.startsWith(filterType);
};

const deconstructFilterKey = (
  filterKey: string
): { filterType: string; filterValue: string } | undefined => {
  const splitKey = filterKey.indexOf(FILTER_KEY_SEPARATOR);
  if (splitKey <= 0) {
    // Filter separator not found or at the beginning of the string
    return undefined;
  }

  return {
    filterType: filterKey.substring(0, splitKey),
    filterValue: filterKey.substring(splitKey + 1),
  };
};

export const getFilterTypeFromFilterKey = (
  filterKey: string
): string | undefined => {
  return deconstructFilterKey(filterKey)?.filterType;
};

export const getFilterValueFromFilterKey = (
  filterKey: string
): string | undefined => {
  return deconstructFilterKey(filterKey)?.filterValue;
};

/* Filter types */
export const BRAND_SAMPLES_FILTER_TYPE = "brand_samples";
export const MAKER_MINUMUM_FILTER_TYPE = "maker_minimum";
export const BRAND_VALUE_FILTER_TYPE = "maker_value";
export const MAKER_SPECIAL_FILTER_TYPE = "maker_special";
export const NAVIGATION_PATH_FILTER_TYPE = "navigation_path";
export const SORT_FILTER_TYPE = "sorting";
export const EXCLUSIVITY_FILTER_TYPE = "exclusivity";
